import {React} from 'react'
import LikedThumb from "./../../assets/svg-icons/linkedThumb"
import RightArrow from './../../assets/svg-icons/rightArrow'
import DeleteIcon from './../../assets/svg-icons/Delete'
import { useNavigate } from "react-router-dom";
import { ROUTES } from '../../constant/routes';
import { FONT_PAIR_HEADER,FONT_PAIR_BODY } from '../../constant';
import { useDispatch } from "react-redux";
import { CHANGE_FONT} from "../../store/types/font";

const PairLiked = ({item, removeLikedPairHandler}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  return (
    <div className="font-pair-box listing-paired-box p-3 pb-5 col-xs-12 col-md-6 col-lg-4">
      <p className="liked23"><LikedThumb /> Liked on {item.createdAt}</p>
      <ul>
          <li>{item.likedPair[0]}</li>
          <li>&</li>
          <li>{item.likedPair[1]}</li>
      </ul>
      <h2  dangerouslySetInnerHTML={{ __html: FONT_PAIR_HEADER.toString() }}  style={{fontFamily: `"${item.likedPair[0]}"` }} />
        <p   dangerouslySetInnerHTML={{ __html: FONT_PAIR_BODY.toString() }} style={{fontFamily: `"${item.likedPair[1]}"` }}></p>
      <div className='font-playerground-sec'>
        <h6>
          <div className='GA_redirectPlaygroundFromLiked' onClick={() => {
            dispatch({ type: CHANGE_FONT, payload: [ item.likedPair[0], item.likedPair[1] ] })
            navigate(`${ROUTES.PLAYGROUND}?fontPair1=${item.likedPair[0]}&fontPair2=${item.likedPair[1]}`)
            }}>Try in playground 
          <RightArrow className='ms-2' /></div>
          <p className="GA_removeFromLiked" onClick={removeLikedPairHandler}><DeleteIcon className='ms-2' /> Remove from liked</p>
        </h6>
      </div>
    </div>
  )
}

export default PairLiked